import React from 'react';
import parse from 'html-react-parser';
import { graphql, useStaticQuery } from 'gatsby';
import { IssueLinks } from './index';
import { WpMenu } from '../index';

const Footer = ({ siteTitle, showIssueLinks }) => {
  const {
    wp: {
      siteOptionsMetaboxSettings: { optionsFooterTitle, optionsFooterEmail },
    },
    wpMenu: { menuItems },
  } = useStaticQuery(graphql`
    query {
      wp {
        ...SiteOptions
      }

      wpMenu(locations: { eq: FOOTER_NAV }) {
        ...MenuItems
      }
    }
  `);
  const footerMenuItems = menuItems?.nodes;

  return (
    <>
      {showIssueLinks && <IssueLinks />}
      <footer className="site-footer">
        <div className="site-footer__inner">
          <div className="site-footer__inner-content">
            <div className="site-footer__title">
              <div className="site-footer__title-text">{optionsFooterTitle}</div>
              <button
                className="site-footer__title-back"
                onClick={() => window.scrollTo({ top: 0 })}
              >
                <span>↑</span> <span>Back to top</span>
              </button>
            </div>
            <div className="site-footer__links">
              <div className="site-footer__links-row">
                <div className="site-footer__links-title">Email</div>
                <div className="site-footer__links-link">
                  <a href={`mailto:${optionsFooterEmail}`}>{optionsFooterEmail}</a>
                </div>
              </div>
              <div className="site-footer__links-row">
                <div className="site-footer__links-title">Subscribe</div>
                <div className="site-footer__links-link">
                  <WpMenu className="site-footer__nav" menuItems={footerMenuItems} />
                </div>
              </div>
            </div>
            <div className="site-footer__baseline">
              <div className="site-footer__baseline-copyright">
                {siteTitle} © {new Date().getFullYear()}
              </div>
              <div className="site-footer__baseline-separator">{parse(`&vert;`)}</div>
              <a href="https://and-now.co.uk/" target="_blank" rel="noreferrer">
                Designed by And–Now
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
